import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { KnmListByPlan } from './KnmListByPlan';

export const KnmListByPlanPage = () => {
  useTitle('Перечень КНМ плана');

  return (
    <Layout withFooter>
      <KnmListByPlan />
    </Layout>
  );
};
